import React, { useEffect, useRef } from 'react';
import Button from '../ClubRegistrationButton/ClubRegistrationButton';
import Styles from './ClubModal.module.scss';

const Modal = (props) => {
  const {
    isOpen, children, setModalOpen, okText, modalMessage, okClick,
  } = props;
  const modalRef = useRef(null);

  const handleClickOutside = (e) => {
    if (modalRef?.current?.contains(e.target)) {
      setModalOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, false);
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  if (!isOpen) {
    return false;
  }

  return (
    <div className={Styles.modalContainer} ref={modalRef}>
      <div className={Styles.overlay}></div>
      <div className={Styles.modal}>
        <div className={Styles.modalMessageTop}>{modalMessage?.topText}</div>
        <div className={Styles.modalMessageBottom}>
          {modalMessage?.bottomText}
        </div>
        {children}
        <div className={Styles.modalButtons}>
          <button
            type="button"
            className={Styles.cancelBtn}
            onClick={() => setModalOpen(false)}
          >
            CANCEL
          </button>
          <span className={Styles.removeBtn}>
            <Button label={okText ?? ''} onClick={okClick && okClick} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Modal;
